import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PHONE_WIDTH, FONT_COLOR } from '~~elements/Const';
import { plugins } from './Const';

const StyledDiv = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  .title {
    border-bottom: 1px solid gray;
    padding: 0.2rem 5rem;
    white-space: nowrap;
  }

  .subtitle {
    padding: 0.2rem 1rem 2rem;
    margin: 0;
    font-size: 1.1rem;
  }

  .plugins {
    width: 780px;
    max-width: 98%;

    display: grid;
    grid-template-columns: repeat(auto-fill, 12rem);
    justify-content: center;
    column-gap: 2rem;
    row-gap: 2.5rem;
  }

  .plugin {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;
    cursor: pointer;
    color: ${FONT_COLOR};
    .img-wrapper {
      position: relative;
      width: 100%;
      text-align: start;
      &:after {
        content: '';
        display: block;
        padding-bottom: 100%;
      }
      > img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .img-cover {
        display: none;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .name {
      font-size: 1.1rem;
      font-weight: normal;
      text-align: start;
      letter-spacing: 1px;
      padding: 0;
      margin: 0.2rem 0;
    }
    .price {
      font-size: 1.2rem;
      font-weight: bold;
      text-align: start;
    }

    &:hover {
      .img-cover {
        display: block;
      }
    }
  }

  @media (max-width: ${PHONE_WIDTH}) {
    .title {
      padding: 0.2rem 2rem;
    }

    .plugins {
      grid-template-columns: repeat(auto-fill, 9rem);
      column-gap: 1rem;
      row-gap: 1.5rem;
    }

    .plugin {
      .name {
        font-size: 1rem;
      }
      .price {
        font-size: 1rem;
        font-weight: bold;
      }
    }
  }
`;

const PluginList = () => {
  return (
    <StyledDiv>
      <h1 className="title">平台擴充套件</h1>
      <h3 className="subtitle">除了方便好用的免費服務，野革也提供更深度的內容給需要的用戶！</h3>
      <div className="plugins">
        {Object.keys(plugins).map((pluginName) => (
          <Link key={pluginName} to={`/shop/plugin/${pluginName}`}>
            <div className="plugin">
              <div className="img-wrapper">
                <img src={plugins[pluginName].src} alt={plugins[pluginName].alt} />
                <div className="img-cover" />
              </div>
              <h3 className="name">{plugins[pluginName].name}</h3>
              <span className="price">{plugins[pluginName].price}</span>
            </div>
          </Link>
        ))}
      </div>
    </StyledDiv>
  );
};

export default PluginList;
